import { createFileRoute } from "@tanstack/react-router";
import { ForgotPasswordComponent } from "../../features/auth/components/ForgotPasswordComponent";

export const Route = createFileRoute("/auth/forgot-password")({
  validateSearch: (search: Record<string, unknown>) => ({
    redirect: search.redirect as string | undefined,
  }),
  component: ForgotPasswordComponent,
});
